import ComparisonBlogForm from "../ComparisonBlogForm";

const ComparisonBlogEdit = () => {
  return <ComparisonBlogForm isEditMode={true} />;
};

export default ComparisonBlogEdit;
